import xlsx from 'xlsx'
import { saveAs } from 'file-saver'
const execelExtension = '.xlsx'
const execelType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'

export default function (data, name, headers) {
  if (headers) {
    data = mapHeaders(data, headers)
  }
  console.log('data: ', data);

  const worksheet = xlsx.utils.json_to_sheet(data)
  const workbook = {
    Sheets: {
      'data': worksheet
    },
    SheetNames: ['data']
  }
  const execelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
  savefile(execelBuffer, name)
}

function savefile(buffer, filename) {
  const data = new Blob([buffer], { type: execelType })
  saveAs(data, filename + '_export_' + new Date().getTime() + execelExtension)
}

function mapHeaders(values, headers) {
  const headersValues = headers.reduce((a, v) => ({ ...a, [v.value]: v.text }), {})
  return values.map(value => {

    return Object.keys(value).reduce((a, v, i) => {
      return ({ ...a, [headersValues[v]]: value[v] })
    }, {})

  }
  )

}